import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ContractNormalizationLayoutProps {
  children: React.ReactNode;
  isLoading: boolean;
}

const ContractNormalizationLayout: React.FC<ContractNormalizationLayoutProps> = ({
  children,
  isLoading,
}) => {
  return (
    <div className="flex flex-col h-full relative">
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 flex items-center justify-center bg-gray-100/75 dark:bg-gray-900/75 backdrop-blur-sm z-50"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.2, delay: 0.1 }}
              className="flex flex-col items-center p-8 rounded-lg shadow-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700"
            >
              <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
              <div className="text-gray-600 dark:text-gray-400 text-xl font-semibold">Loading Contract Data...</div>
              <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">Please wait while we prepare the normalization tab.</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <div className="flex-grow overflow-auto bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-1 flex-col md:flex-row min-h-0 h-full">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContractNormalizationLayout;
